export enum enumSasServiceStatus {
  'Inactive' = 0,
  'Active' = 1,
}

export namespace enumSasServiceStatus {
  export function values() {
    return Object.keys(enumSasServiceStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
